import { singletonFactory } from '@warehouse/shared/util';
import { QuickbaseTabService } from './quickbase-tab.service';
import { QuickbaseTabServiceImpl } from './quickbase-tab.service.impl';
import { TabType } from '../quickbase-types';

export const quickbaseTabServiceSingletons: Record<
	TabType,
	ReturnType<typeof singletonFactory<QuickbaseTabService>>
> = {
	[TabType.NxTension]: singletonFactory({
		factory: () => new QuickbaseTabServiceImpl(TabType.NxTension),
	}),

	[TabType.NxOrders]: singletonFactory({
		factory: () => new QuickbaseTabServiceImpl(TabType.NxOrders),
	}),

	[TabType.NxInventory]: singletonFactory({
		factory: () => new QuickbaseTabServiceImpl(TabType.NxInventory),
	}),
};
